import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Image, Button, Tooltip } from "antd";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { getDateYYYYMMDD, formateDate } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import { req_page_gsm_singer_enrolment } from "../../api";

class LastEnrolmentView extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {
      StaffType: "masses",
      SchoolGateLocation: "NONE",
      DepartmentMainName: "",
      StaffName: "",
      StaffCode: "",
      SignUserCode: "",
      StaffCellphone: "",
      SignDescription: "",
      SignStatus: "",
      RecordDateString: "",
      RecordCreateDateTime: formateDate(new Date()),
      StaffPicUrl: "https://secret.tut.edu.tw/var/file/1/1001/img/430/logo.jpg",
    },
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: getDateYYYYMMDD(new Date()),
    isShowModal: false,
    picUrl: "",
    identity: "student",
    gateLocation: "NONE",
  };

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_gsm_singer_enrolment(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const item = result.data[0];
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ item, items, pagination, loading: false });

      const { StaffType, SchoolGateLocation } = item;
      this.setState({
        identity: StaffType,
        gateLocation: SchoolGateLocation === "第一校門" ? "GATEA" : "GATEB",
      });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { item, identity } = this.state;
    const {
      SchoolGateLocation,
      DepartmentMainName,
      StaffName,
      StaffCode,
      SignUserCode,
      StaffPicUrl,
      RecordCreateDateTime,
      SignStatus,
    } = item;
    const title = (
      <Tooltip placement="top" title="重新整理">
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>
      </Tooltip>
    );
    return (
      <Card>
        <div className="text-center" style={{ width: "100%" }}>
          {title}
          {SchoolGateLocation === "NONE" ? (
            <></>
          ) : (
            <div
              style={{
                fontSize: "1.5em",
                textAlign: "center",
                width: "400px",
                border: "1px solid white",
                margin: "15px auto",
                padding: "5px",
                borderRadius: "5px",
                backgroundColor: "#26004d",
                color: "white",
                boxShadow: "1px 2px 9px #000",
              }}
            >
              <span
                style={{ fontSize: "1.2em", fontWeight: "bold", color: "gold" }}
              >
                {SchoolGateLocation}
              </span>
              <br></br>
              <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                最近一筆時間：{formateDate(RecordCreateDateTime)}
              </span>
              <br></br>
              <Image width={80} src={StaffPicUrl} />
              <p></p>
              {identity === "teacher" ? (
                <span>教職員身份</span>
              ) : (
                <spanp>學生身份</spanp>
              )}
              <br></br>
              <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                {DepartmentMainName}
              </span>
              <br></br>
              <span
                style={{ fontSize: "1.2em", fontWeight: "bold", color: "gold" }}
              >
                {StaffName}
              </span>
              <br></br>
              <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                {StaffCode}
              </span>
              <br></br>
              <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                {SignUserCode}
              </span>
              <div
                style={
                  SignStatus === "IN"
                    ? { backgroundColor: "#ffb3d9", color: "#943126" }
                    : { backgroundColor: "#ABEBC6", color: "#0B5345" }
                }
              >
                {SignStatus === "IN" ? "入校" : "離校"}登記成功
              </div>
            </div>
          )}
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(LastEnrolmentView);
